<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="lg:w-1/3 sm:w-1/2 w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                        <gridPrincipalItem
                          img="agro"
                          :name="response.description"
                          description="Alias"
                          :name2="response.serie"
                          :description2="$t('Labels.Serie')"
                        ></gridPrincipalItem>
                        <div class="absolute right-0 top-0">
                            <vs-button  @click="deviceStatistics(response.agro_id)" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                            </vs-button>
                            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'"  @click="goToConfig(response.agro_id)" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                            </vs-button>
                        </div>
                        <vs-divider/>
                        <valueItem :description="$t('Labels.GroundTemperature')" img="temperature" :value="parseFloat(response.temp || 0).toFixed(2)" unit="°C" :min="response.min_temp" :max="response.max_temp"></valueItem>
                        <valueItem :description="$t('Labels.EnvTemperature')" img="pressure" :value="parseFloat(response.atemp || 0).toFixed(2)" unit="°C" :min="response.min_atemp" :max="response.max_atemp"></valueItem>
                        <valueItem :description="$t('Labels.Humidity')" img="humedad" :value="parseFloat(response.ahum || 0).toFixed(2)" unit="%" :min="response.min_ahum" :max="response.max_ahum"></valueItem>
                        <valueItem :description="$t('Labels.HumidityGround')" img="droplet" :value="parseFloat(response.ground_hum || 0).toFixed(2)" unit="%" :min="response.min_ground_hum" :max="response.max_ground_hum"></valueItem>
                        <valueItem :description="$t('Labels.Precipitation')" img="lluvia" :value="parseFloat(response.rain_level || 0).toFixed(2)" unit="%" :min="response.min_rain_level" :max="response.max_rain_level"></valueItem>
                        <valueItem :description="$t('Labels.Light')" img="nivel_luz" :value="parseFloat(response.light_level || 0).toFixed(2)" unit="%" :min="response.min_light_level" :max="response.max_light_level"></valueItem>
                        <valueItem :description="$t('Labels.Date')" img="fecha" :value="response.updated_at"></valueItem>
                    </vx-card>
                </div>

            </div>
            <div class="vx-col lg:w-2/3 sm:w-2/3 w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                    <div class="avatar-info-container">
                        <span class="account-number">
                           {{$t("Labels.DeviceLocation")}}
                        </span>
                        <feather-icon
                          icon="EditIcon"
                          @click="editMap = true"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="!editMap"/>
                        <feather-icon
                          icon="SaveIcon"
                          @click="saveMap()"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="editMap && $store.state.AppActiveUser.userRole === 'MA'"/>
                        <div class="map-container basic-example" v-if="status_mapa">
                            <l-map :center="center" :zoom="zoom" v-if="response">
                                <l-tile-layer :attribution="attribution" :url="url">
                                </l-tile-layer>
                                <l-marker :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                    <l-icon :icon-anchor="staticAnchor">
                                        <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                    </l-icon>
                                </l-marker>
                            </l-map>
                        </div>
                        <div class="mt-2">
                          <label>{{$t('Labels.References')}}:</label>{{response.location_string  }}
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                    <vs-divider/>
                    <div class="container-alerts" v-if="showAlerts">
                        <minMaxItem
                          :title="$t('Labels.GroundTemperature')"
                          :min="response.min_temp"
                          :max="response.max_temp"
                          unit="°C"
                          img="temperature_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_temp"
                          paramMax="max_temp"
                          type="PUT"
                          :limitMin="limits.temp.min || 0"
                          :limitMax="limits.temp.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.EnvTemperature')"
                          :min="response.min_atemp"
                          :max="response.max_atemp"
                          unit="°C"
                          img="pressure_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_atemp"
                          paramMax="max_atemp"
                          type="PUT"
                          :limitMin="limits.atemp.min || 0"
                          :limitMax="limits.atemp.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Humidity')"
                          :min="response.min_ahum"
                          :max="response.max_ahum"
                          unit="%"
                          img="humedad_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_ahum"
                          paramMax="max_ahum"
                          type="PUT"
                          :limitMin="limits.ahum.min || 0"
                          :limitMax="limits.ahum.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.HumidityGround')"
                          :min="response.min_ground_hum"
                          :max="response.max_ground_hum"
                          unit="%"
                          img="droplet_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_ground_hum"
                          paramMax="max_ground_hum"
                          type="PUT"
                          :limitMin="limits.ground_hum.min || 0"
                          :limitMax="limits.ground_hum.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Precipitation')"
                          :min="response.min_rain_level"
                          :max="response.max_rain_level"
                          unit="%"
                          img="lluvia_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_rain_level"
                          paramMax="max_rain_level"
                          type="PUT"
                          :limitMin="limits.rain_level.min || 0"
                          :limitMax="limits.rain_level.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Light')"
                          :min="response.min_light_level"
                          :max="response.max_light_level"
                          unit="%"
                          img="nivel_luz_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_light_level"
                          paramMax="max_light_level"
                          type="PUT"
                          :limitMin="limits.light_level.min || 0"
                          :limitMax="limits.light_level.max || 0"
                        />
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import { request } from '@/request.js'
/* global L:true */

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    minMaxItem,
    valueItem,
    gridPrincipalItem
  },

  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      staticAnchor: [12, 27],
      response: [],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      showAlerts: false,
      editMap: false,
      limits: {}
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.showAlerts = true
        this.limits = response.data.limits
        const [lat, long] = this.response.latlong.split(',')
        this.marker = L.latLng(lat, long)
        this.center = L.latLng(lat, long)
        this.status_mapa = true
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'PUT',
        params: {
          latlong: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/agro/config/${this.uuid}`
    },

    deviceStatistics () {
      window.location.href = `/agro/statistics/${this.uuid}`
    }

  },
  sockets: {
    agro (payload) {
      if (this.uuid === payload.uuid) {
        this.response.ahum = payload.ahum
        this.response.atemp = payload.atemp
        this.response.ground_hum = payload.ground_hum
        this.response.rain_level = payload.rain_level
        this.response.status = payload.status
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
  .vue2leaflet-map >>> .leaflet-shadow-pane {
    display: none !important;
  }
>>>.vs-input--label {
    padding: 0;
  }
</style>
